/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import {Button} from 'react-bootstrap';

class PhoneVerificationCodeButtons extends React.Component<Props> {

	static defaultProps: Props = {
		onIndicateVerificationCodeNotReceived: () => {
			// do nothing
		},
		onRetryPhoneVerificationStart: () => {
			// do nothing
		},
		onSubmitVerificationCode: () => {
			// do nothing
		},
		submitDisabled: false,
		verificationStopped: false
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		const verificationStopped: boolean = props.verificationStopped;
		const submitDisabled: boolean = props.submitDisabled;
		const onSubmitVerificationCode: () => void = props.onSubmitVerificationCode;
		const onIndicateVerificationCodeNotReceived: () => void = props.onIndicateVerificationCodeNotReceived;
		const onRetryPhoneVerificationStart: () => void = props.onRetryPhoneVerificationStart;

		return (
			<React.Fragment>
				{
					!verificationStopped &&
					<Button
						type="button"
						className="float-start"
						variant="link"
						onClick={onIndicateVerificationCodeNotReceived}
						disabled={submitDisabled}>
						{'Ik heb geen code ontvangen'}
					</Button>
				}
				<Button
					type="button"
					className="float-end"
					variant="primary"
					onClick={verificationStopped ? onRetryPhoneVerificationStart : onSubmitVerificationCode}
					disabled={submitDisabled}>
					{verificationStopped ? 'Stuur nieuwe code' : 'Verifieer'}
				</Button>
			</React.Fragment>
		);
	}
}

export default PhoneVerificationCodeButtons;
